import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Navigate } from "react-router-dom";
import { getRemainingTime, logout, isConnectedServer } from './Network';
import { Stack } from '@mui/material';
import { getSentence } from './translations';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { MobileView, isMobile, BrowserView } from "react-device-detect";
import MicIcon from '@mui/icons-material/Mic';
import HomeIcon from '@mui/icons-material/Home';
import { matomoTracker } from './matomoTracker';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { disconnect } from './Cookies';
import UploadModal from './UploadModal';
import ErrorModal from './ErrorModal';

import '../css/topbar.css'
import '../css/globalVars.css'



export class Topbar extends React.Component 
{
  constructor(props)
  {
    super(props);

    this.state = {
      navigateTo: "",
      remainingTime: "",
      anchorElUser: null,
      buyCreditButton: "",
      disableBttn: false,
      showUploadModal: false,
      showErrorModal: false,
      errorMessage: ""
    }

    this.settings = [[getSentence(11), ()=>this.setState({navigateTo: <Navigate to="/profile" replace={false} />})],
                      [getSentence(68), ()=>this.setState({navigateTo: <Navigate to="/SellingPage" replace={false} />})], [getSentence(12), logout]];

    this.updateRemainingTime();

    this.updateTimeRemaining = setInterval(() => {
      this.updateRemainingTime();
    }, 60*1000);
  }


  componentWillUnmount() 
  {
    clearInterval(this.updateTimeRemaining);
  }

  componentDidMount()
  {
    this.checkLoginState()
    matomoTracker()
  }


  async updateRemainingTime()
  {
    const remainingTime = await getRemainingTime();
    const hours = ~~(Number(remainingTime[0] + remainingTime[1]) / 3600);
    var minutes = ~~((Number(remainingTime[0] + remainingTime[1]) - (hours * 3600)) / 60);
    if (minutes < 10){
      minutes = "0" + String(minutes)
    }
    const time = hours + "h" + minutes;
    this.setState({remainingTime: time})

    //display the buy credits button if the remaining time is less than 30 minutes
    if (remainingTime[0] + remainingTime[1] < 1800)
    {
      const button = <a href="/SellingPage" className="buy-credits-cta-link">
                        <Button variant="contained" className="buy-credits-cta">
                          {getSentence(68)}
                        </Button>
                     </a>
      this.setState({buyCreditButton: button})
    }
  }


  handleUploadSuccess = () => {
    // Close the upload modal
    this.setState({ showUploadModal: false });
    
    if (!this.state.disableBttn) {
      // Use callback to update meetings list instead of page reload
      if (this.props.onFileUploadSuccess) {
        this.props.onFileUploadSuccess();
      } else {
        // Fallback to page reload if callback not provided 
        window.location.reload();
      }
    }
  }

  handleUploadError = (errorMessage) => {
    this.setState({
      showUploadModal: false,
      showErrorModal: true,
      errorMessage: errorMessage
    });
  }


  checkLoginState()
  {
    //Disconnect the user to avoid problems if the navigator cookie is set but the server's session is not valid.
    if (!isConnectedServer())
    {
      disconnect()
      window.location.reload(false);
    }    
  }


  render()
  {
    
    const handleOpenUserMenu = (event) => {
      this.setState({anchorElUser: event.currentTarget});
    };

    
    const handleCloseUserMenu = () => {
      this.setState({anchorElUser: null});
    };


    //we print the button to create a new meeting only if aren't actually on a meeting.
    var linkToNewMeeting = <Box sx={{ flexGrow: 1, display: 'flex' }} id="c6d4s5"></Box>;

    if (this.props.recording === true && !this.state.disableBttn)
    {
      this.setState({disableBttn : true})
    }
    else if (this.props.recording === false && this.state.disableBttn)
    {
      this.setState({disableBttn : false})
    }


    const btn = <Button sx={{ my: 2, color: 'var(--textWhite)', display: 'block', marginTop: "0px", marginBottom: "0px" }} 
                          onClick={()=>this.setState({navigateTo : <Navigate to="/record" replace={false} />})}
                          data-selected={window.location.pathname==="/record"}>
                  <MobileView><MicIcon /></MobileView>
                    <BrowserView>
                      <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <MicIcon /><p style={{marginLeft: "10px"}}>{getSentence(125)}</p>
                      </div>
                    </BrowserView>
                </Button>    

    linkToNewMeeting = <Box sx={{ flexGrow: 1, display: 'flex'}} id="c6d4s5">  
      {btn}
    </Box>

    if(isMobile)  //center the button
    {
      linkToNewMeeting = <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }} id="c6d4s5">  
        {btn}
    </Box>
    }
  

    var homeButton =  <Button sx={{ my: 2, color: 'var(--textWhite)', display: 'block', marginTop: "0px", marginBottom: "0px" }} 
                              onClick={() => {
                                // On mobile, if we're on the right panel (meeting view), swipe back to meetings list
                                if (isMobile && this.props.activePanelIndex === 1 && this.props.onMobileHomePress) {
                                  this.props.onMobileHomePress();
                                } else {
                                  // Otherwise, use normal navigation
                                  this.setState({navigateTo : <Navigate to="/" replace={false} />});
                                }
                              }} 
                              data-selected={window.location.pathname==="/" || window.location.pathname.includes("/meeting/")}
                              disabled={this.state.disableBttn}>

                        <MobileView><HomeIcon /></MobileView>
                        <BrowserView>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <HomeIcon /><p style={{marginLeft: "10px"}}>{getSentence(124)}</p>
                          </div>
                        </BrowserView>
                      </Button>



    var uploadButton =  <Button sx={{ my: 2, color: 'var(--textWhite)', display: 'block', marginTop: "0px", marginBottom: "0px" }} 
                                onClick={()=>{
                                  this.setState({ showUploadModal: true });
                                }}
                                disabled={this.state.disableBttn} >
                            <MobileView><FileUploadIcon /></MobileView>
                            <BrowserView>
                              <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <FileUploadIcon /><p style={{marginLeft: "10px"}}>{getSentence(123)}</p>
                              </div>
                            </BrowserView>
                        </Button>

    var appBarStyle = {position:"static"}

    return (
      <>
        <AppBar className={'unpenAppBar'} style={{ background:'var(--topbarPrimaryColor)'}} sx={appBarStyle} elevation={0}>
         
          <Box sx={{ flexGrow: 1}}>
            <Toolbar style={{zIndex: 5}}>
              <div id="navigateTo">{this.state.navigateTo}</div>           

              <div id='browsersLeftContainer'>
                {homeButton}
              </div>

            <BrowserView>
              <div id='browsersMiddleContainer'>
                <div style={{width: "100px"}}>     </div>
                {uploadButton}
                <div style={{width: "30px"}}>     </div>
                {linkToNewMeeting}
              </div>
            </BrowserView>
            <MobileView>
              <div style={{display: "flex"}}>
                <div style={{width: "50px"}}>     </div>
                {uploadButton}
                {linkToNewMeeting}
              </div>
            </MobileView>




            <Stack direction="row" spacing={2} alignItems="center" 
                            style={{display:"flex", marginLeft:"auto", height: "100%", position: "absolute", right: "1%"}}>
              <div id='browsersRightContainer'> {this.state.buyCreditButton}</div>
              
                <Button sx={{ my: 2, color: 'var(--textWhite)', display: 'block', marginTop: "0px", marginBottom: "0px" }} 
                                data-selected={window.location.pathname==="/SellingPage" || window.location.pathname.includes("/paiement/")}
                                onClick={()=>this.setState({navigateTo : <Navigate to="/SellingPage" replace={false} />}
                                )}
                                disabled={this.state.disableBttn}
                              >
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                      <BrowserView>
                        {getSentence(13)} : 
                      </BrowserView>
                      {this.state.remainingTime}
                    </div>
                </Button>

              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title={getSentence(10)}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }} disabled={this.state.disableBttn}>
                    <AccountCircleIcon fontSize='large' style={{ color: 'var(--textWhite)'}}/>
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{mt: '45px' }}
                  id="menu-appbar"
                  anchorEl={this.state.anchorElUser}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(this.state.anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {this.settings.map((setting) => (
                    <MenuItem key={setting[0]} onClick={setting[1]}>
                      <Typography textAlign="center">{setting}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Stack>
            
          </Toolbar>
        </Box>
      </AppBar>

      {/* Upload Modal */}
      <UploadModal
        open={this.state.showUploadModal}
        onClose={() => this.setState({ showUploadModal: false })}
        onUploadSuccess={this.handleUploadSuccess}
        isRecording={this.state.disableBttn}
      />

      {/* Error Modal */}
      <ErrorModal
        open={this.state.showErrorModal}
        onClose={() => this.setState({ showErrorModal: false, errorMessage: "" })}
        title="Upload Error"
        message={this.state.errorMessage}
        allowHtml={true}
      />
    </>
    );
  }
}

